import React from 'react';

export default {
  width: 29,
  height: 16,
  content: <path d="M0 7.874h27.5M20 1l7 6.875-7 6.874" fill="none" stroke="#000" strokeWidth="2" />
};
